import React, { useEffect, useState, useMemo } from 'react';
import AdTable from './AdsTable.js';
import { useTableState } from '../utils/useTableState.js';
import { columnsConfig } from '../MyAds/tableConfig.js';
import FilterBar from './FilterBar.js';
const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  },
  {
    value: "classifiedads",
    label: "Classified Ads"
  }
]
// Status options from cellRenderers.js
const STATUS_OPTIONS = [
    { value: 2, label: 'Saved' },
    { value: 3, label: 'Picked' },
    { value: 4, label: 'Completed' },
    { value: 5, label: 'Rejected' },
    { value: 6, label: 'Accepted' },
];

const ReadyToLiveAds = ({ isActive }) => {
    const {
        fetchReadyToLiveAds,
        currentPage,
        adsData,
        designers,
        contentWriters,
        fetchDesigners,
        fetchContentWriters,
        loading,
        totalPages,
        showActionsMenu,
        modal,
        drawer,
        expandedVersionsRow,
        actionHandlers,
        renderCell,
        getModalAlt,
        closeExpandedRows,
        handleDesignerChange,
        handleContentWriterChange,
        handlePageClick,
        handleGoToLive,
        goLiveLoadingIdx,
        fetchContent
    } = useTableState();

    // Filter state
    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
    const [designer, setDesigner] = useState(null);
    const [contentWriter, setContentWriter] = useState(null);
    const [status, setStatus] = useState(null);
    const [adType, setAdType] = useState(null);
    const [search, setSearch] = useState('');

    // Designer options for react-select
    const designerOptions = useMemo(() =>
        designers.map(d => ({ value: d.designer_id, label: d.name })),
        [designers]
    );



    // Fetch designers and content writers on mount
    useEffect(() => {
        fetchDesigners();
        fetchContentWriters();
    }, []);

    // Fetch ads on filter or page change
    useEffect(() => {
        fetchReadyToLiveAds(currentPage, isActive, {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            designerId: designer ? designer.value : null,
            contentWriterId: contentWriter ? contentWriter.value : null,
            status: status ? status.value : null,
            adType: adType && adType.value !== 'all' ? adType.value : null,
            search: search || null,
        });
    }, [isActive, currentPage, dateRange, designer, contentWriter, status, adType, search]);

    // Handlers
    const handleDateChange = (val) => setDateRange(val);
    const handleDesignerChangeSelect = (val) => setDesigner(val);
    const handleContentWriterChangeSelect = (val) => setContentWriter(val);
    const handleStatusChange = (val) => setStatus(val);
    const handleAdTypeChange = (val) => setAdType(val);
    const handleSearchChange = (val) => setSearch(val);

    return (
        <div>
            <FilterBar
                dateRange={dateRange}
                onDateChange={handleDateChange}
                designer={designer}
                onDesignerChange={handleDesignerChangeSelect}
                designerOptions={designerOptions}
                contentWriter={contentWriter}
                onContentWriterChange={handleContentWriterChangeSelect}
                contentWriterOptions={contentWriters}
                showContentWriter={true}
                status={status}
                onStatusChange={handleStatusChange}
                statusOptions={STATUS_OPTIONS}
                showDesigner={true}
                showStatus={false}
                adType={adType}
                onAdTypeChange={handleAdTypeChange}
                adTypeOptions={types}
                showAdType={true}
                search={search}
                onSearchChange={handleSearchChange}
                showSearch={true}
            />
            <AdTable
                data={adsData}
                columns={columnsConfig.ready_to_live}
                loading={loading}
                totalPages={totalPages}
                currentPage={currentPage}
                onPageClick={handlePageClick}
                designers={designers}
                contentWriters={contentWriters}
                showActionsMenu={showActionsMenu}
                modal={modal}
                drawer={drawer}
                expandedVersionsRow={expandedVersionsRow}
                actionHandlers={actionHandlers}
                renderCell={renderCell}
                getModalAlt={getModalAlt}
                closeExpandedRows={closeExpandedRows}
                handleDesignerChange={handleDesignerChange}
                handleContentWriterChange={handleContentWriterChange}
                handleGoToLive={handleGoToLive}
                goLiveLoadingIdx={goLiveLoadingIdx}
                fetchContent={fetchContent}
            />
        </div>
    );
};

export default ReadyToLiveAds; 